import { createFileRoute, redirect } from '@tanstack/react-router';
import DevLayout from '@/components/DevLayout/DevLayout';
import { isFormsFixturePage } from '@/components/DevLayout/isFormsFixturePage';

export const Route = createFileRoute('/dev')({
  beforeLoad: async ({ context, location }) => {
    if (isFormsFixturePage(location.pathname)) {
      return;
    }
    const { isAuthenticated } = await context.auth.awaitAuthState();
    if (!isAuthenticated) {
      throw redirect({
        to: '/login',
        search: {
          redirect: location.href,
        },
      });
    }
  },
  component: DevLayout,
});
